var map = {
	"./ChangeContextPage.tsx": 35911,
	"./CustomOrderStatusPage.tsx": 82299,
	"./OsnCreateQuotePage.tsx": 28190,
	"./OsnEditQuotePage.tsx": 92222,
	"./OsnOptOutConfirmationPage.tsx": 51852,
	"./OsnOptOutPage.tsx": 21843,
	"./OsnOrderStatusLookupPage.tsx": 74578,
	"./OsnQuoteDetailsPage.tsx": 48888,
	"./OsnQuoteListPage.tsx": 76850,
	"./RedirectToRewardsGalleryPage.tsx": 67335,
	"./RewardsGalleryPage.tsx": 73188,
	"./SubscriptionsDashboardPage.tsx": 29835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10770;